const BreadcrumbList = {
  invoices: {
    '/invoices': 'Invoices',
    '/invoices/:invoiceNumber/:invoiceId': (params: { invoiceNumber: string }) => params.invoiceNumber,
  },
  upload: {
    '/upload': 'Upload Documents',
  },
  documents: {
    '/documents': 'Invoices',
    '/documents/:jobId': 'Preview',
  },
  reports: {
    '/reports': 'Reports',
    '/reports/summary': 'Summary',
    '/reports/:reportName/:reportId': (params: { reportName: string }) => params.reportName,
  },
  profile: {
    '/profile': 'Profile',
  },
  debtor: {
    '/debtors': 'Debtors',
  },
  dashboard: {
    '/dashboard': 'Dashboard',
  },
}

const BreadcrumbIcons: { [key: string]: string } = {
  dashboard: 'menubar/icon_dashboard_active',
  invoices: 'menubar/icon_invoices_active',
  reports: 'menubar/icon_reports_active',
  upload: 'menubar/icon_upload_active',
  documents: 'menubar/icon_invoices_active',
  profile: 'menubar/icon_settings_active',
  debtors: 'menubar/icon_debtors_active',
}

/** ***** Breadcrumb Logic *****
 * Switch statement to determine which breadcrumbs are to display on the pages
 */
const renderBreadcrumbs = (path: string) => {
  let breadcrumbs = null
  switch (true) {
    case /\/invoices/.test(path):
      breadcrumbs = BreadcrumbList.invoices
      break
    case /\/reports/.test(path):
      breadcrumbs = BreadcrumbList.reports
      break
    case /\/upload/.test(path):
      breadcrumbs = BreadcrumbList.upload
      break
    case /\/documents/.test(path):
      breadcrumbs = BreadcrumbList.documents
      break
    case /\/profile/.test(path):
      breadcrumbs = BreadcrumbList.profile
      break
    case /\/debtor/.test(path):
      breadcrumbs = BreadcrumbList.debtor
      break
    case /\/dashboard/.test(path):
      breadcrumbs = BreadcrumbList.dashboard
      break
    default:
      break
  }
  return breadcrumbs
}

export const getBreadcrumbsIcon = (pathname: string) => {
  // Split the pathname into an array of parts using '/' as the delimiter
  const pathParts = pathname.split('/')

  // Get the first part of the path (excluding the empty string at the beginning)
  const firstName = pathParts[1]
  return BreadcrumbIcons[firstName]
}

export default renderBreadcrumbs
